

































































import { ForgotPassword } from '@/components/familyPortal/popupComponents/forgetPassword/ForgotPassword';
export default ForgotPassword;
